
// AppMessageContext.tsx
import "./AppMessage.scss";
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

type MessageType = 'success' | 'error';

interface Message {
    id: number;
    type: MessageType;
    title: string;
    message: string;
}

interface MessageContextProps {
    showMessage: (message: Omit<Message, 'id'>) => void;
}

const MessageContext = createContext<MessageContextProps | undefined>(undefined);

let idCounter = 0;

export const AppMessageProvider = ({ children }: { children: ReactNode }) => {
    const [toasts, setToasts] = useState<Message[]>([]);

    const showMessage = (toast: Omit<Message, 'id'>) => {
        const id = ++idCounter;
        setToasts((prev) => [...prev, { ...toast, id }]);
        setTimeout(() => {
            setToasts((prev) => prev.filter((t) => t.id !== id));
        }, 3000);
    };

    // ✅ đăng ký hàm showMessage với AppMessage
    useEffect(() => {
        AppMessage._register(showMessage);
    }, []);

    return (
        <MessageContext.Provider value={{ showMessage }}>
            {children}
            <div className="app-message-container">
                {toasts.map((toast) => (
                    <div key={toast.id} className={`app-message-toast ${toast.type}`}>
                        <div className="app-message-icon">
                            {toast.type === 'success' ? <i className="fa fa-solid fa-check"></i> : <i className="fa fa-solid fa-check"></i>}
                        </div>
                        <div>
                            <strong>{toast.title}</strong>
                            <div>{toast.message}</div>
                        </div>
                    </div>
                ))}
            </div>
        </MessageContext.Provider>
    );
};

const useMessage = () => {
    const context = useContext(MessageContext);
    if (!context) throw new Error('useToast must be used within a ToastProvider');
    return context;
};

let toastFn: ReturnType<typeof useMessage>['showMessage'];

export const AppMessage = {
    success({ title, message }: { title: string; message: string }) {
        toastFn?.({ type: 'success', title, message });
    },
    error({ title, message }: { title: string; message: string }) {
        toastFn?.({ type: 'error', title, message });
    },
    _register(fn: typeof toastFn) {
        toastFn = fn;
    },
};